import routes from 'app/zap-mover/routes';

export default {
  reducers: {},
  actionTypes: {},
  routes,
};
